import { getActionTypes } from './get-actions';

export const getReducer = (actionPrefix) => (action) => ({
  // START
  [getActionTypes(actionPrefix).QUERY_START]: (state) => ({
    isLoading: action.payload.isInfinite ? state.isLoading : true,
    isLoadingInfinite: action.payload.isInfinite ? true : state.isLoadingInfinite,
  }),

  // SUCCESS
  [getActionTypes(actionPrefix).QUERY_SUCCESS]: (state) => ({
    contents: [...state.contents, ...action.payload.data.cardList],
    nextPagePath: action.payload.data.nextPagePath,
    isLoading: false,
    isLoadingInfinite: false,
    rel: action.payload.data.customRel,
  }),
  // FAILURE
  [getActionTypes(actionPrefix).QUERY_FAILURE]: () => ({
    error: true,
    isLoading: false,
    isLoadingInfinite: false,
  }),
});
